import { usePathname } from 'next/navigation';

import { getGlobalArgs } from '@/root/global';
import { AbsolutePath } from '@/types/navigation';
import { isPathToSpec } from '@/utils/dynamic';
import { isExternalLink, resolvePath, toAbsolutePath } from '@/utils/navigation';

const endIsFolder = (path: string) => path.endsWith('/ug') || path.endsWith('ug/');

const processPath = (resolved: AbsolutePath) => {
  if (endIsFolder(resolved)) return `/${resolved}/index`;

  if (isPathToSpec(resolved)) {
    return `${getGlobalArgs('NEXT_PUBLIC_SPECS_PROXY_URL')}${resolved}`;
  }
  return resolved;
};

export const usePathResolver = (path: string) => {
  const pathName = usePathname();

  if (isExternalLink(path)) return { resolvedPath: path, isExternal: true, currentPathName: pathName };

  const resolved = resolvePath(toAbsolutePath(pathName), path);
  return {
    currentPathName: pathName,
    resolvedPath: processPath(resolved),
    isExternal: false,
  };
};
